export default __webpack_public_path__ + "static/media/background_4.2878881b.jpg";